export const ETaux = {
    AUTO: "auto",
    CENT: "1",
		CINQUANTE: "0.5",
		GRATUIT: "free",
} as const;

export type TauxValue = typeof ETaux[keyof typeof ETaux];